module.exports = __webpack_public_path__ + "img/next_24_2.1944db91.svg";